import type { ReadModeContent } from '@lumapps/contents/types';
import { TranslateObject } from '@lumapps/translations';

export enum ViewModeEnum {
    LIST = 'LIST',
    SPOTLIGHT = 'SPOTLIGHT',
}

export type ViewMode = keyof typeof ViewModeEnum;

/**
 * https://api.lumapps.com/docs/output/_schemas/streamconf.html
 * https://api.lumapps.com/docs/output/_schemas/filterfields.html
 */
export interface ContentStream {
    id?: string;
    uid: string;
    label: TranslateObject;
    description?: string;
    filterFields: {
        favoriteSitesOnly: boolean;
        defaultInstanceRelatives: boolean;
        contentTypeIds: string[];
        highlightedOnly: boolean;
        featuredOnly: boolean;
        instanceIds: string[];
        metadataList: [Record<string, string[]>];
        categories: string[];
    };
    priority: number;
    isViewLocked: boolean;
    viewMode: ViewMode;
    limit: number;
    feedIds: string[];
    createdAt?: string;
}

/**
 * Content returned by the content stream list.
 * Subset of the real content API.
 */
export type StreamContent = Pick<
    ReadModeContent,
    | 'authorDetails'
    | 'comments'
    | 'customContentTypeDetails'
    | 'customContentTypeTags'
    | 'excerpt'
    | 'hasCommentWidget'
    | 'instance'
    | 'liked'
    | 'likes'
    | 'publicationDate'
    | 'slug'
    | 'thumbnail'
    | 'title'
    | 'writerDetails'
> & {
    uid: string;
};
